import actionTypePrefixes from "../../actions/actionTypePrefixes"

const initialState = {
  isLoading: true,
  loadingFailed: false,
  widgets: {
    performanceComparisonChart: {
      data: null,
      subtitle: null,
    },
    lengthOfService: {
      data: null,
      subtitle: null,
    },
    averageLengthOfService: {
      data: null,
      subtitle: null,
    },
    happyScale: {
      data: null,
      subtitle: null,
    },
    totalEmployees: {
      data: null,
      subtitle: null,
    },
    challengesFaced: {
      data: null,
      subtitle: null,
    },
    overallLabourTurnover: {
      data: null,
      subtitle: null,
    },
    directReports: {
      data: null,
      subtitle: null,
    },
    top5LD: {
      data: null,
      subtitle: null,
    },
    doingWell: {
      data: null,
      subtitle: null,
    },
    needsImproving: {
      data: null,
      subtitle: null,
    },
    pulseCheckResponses: {
      data: null,
      subtitle: null,
    },
    engagementScoreDoughnut: {
      data: null,
      subtitle: null,
    },
    performanceScoreDoughnut: {
      data: null,
      subtitle: null,
    },
    freedom: {
      data: null,
      subtitle: null,
    },
    meetingNeeds: {
      data: null,
      subtitle: null,
    },
  },
}

export default function intelAndInsightsReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.IntelAndInsights) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.IntelAndInsights, "")

  switch (actionType) {
    case "LOAD_DASHBOARD_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: true,
        loadingFailed: false,
        widgets: {
          performanceComparisonChart: {
            data: null,
            subtitle: null,
          },
          lengthOfService: {
            data: null,
            subtitle: null,
          },
          happyScale: {
            data: null,
            subtitle: null,
          },
          averageLengthOfService: {
            data: null,
            subtitle: null,
          },
          challengesFaced: {
            data: null,
            subtitle: null,
          },
          totalEmployees: {
            data: null,
            subtitle: null,
          },
          directReports: {
            data: null,
            subtitle: null,
          },
          top5LD: {
            data: null,
            subtitle: null,
          },
          doingWell: {
            data: null,
            subtitle: null,
          },
          needsImproving: {
            data: null,
            subtitle: null,
          },
          overallLabourTurnover: {
            data: null,
            subtitle: null,
          },
          pulseCheckResponses: {
            data: null,
            subtitle: null,
          },
          engagementScoreDoughnut: {
            data: null,
            subtitle: null,
          },
          performanceScoreDoughnut: {
            data: null,
            subtitle: null,
          },
          freedom: {
            data: null,
            subtitle: null,
          },
          meetingNeeds: {
            data: null,
            subtitle: null,
          },
        },
      }

    case "LOAD_DASHBOARD_DATA_SUCCESS":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        widgets: {
          ...state.widgets,
          lengthOfService: action.payload.data.lengthOfServiceGrouped,
          averageLengthOfService: action.payload.data.lengthOfServiceAverage,
          totalEmployees: action.payload.data.totalEmployees,
          happyScale: action.payload.data.happyScale,
          challengesFaced: action.payload.data.challengesFaced,
          directReports: action.payload.data.directReports,
          pulseCheckResponses: action.payload.data.pulseChecks,
          performanceComparisonChart: action.payload.data.performanceComparisonChart,
          top5LD: action.payload.data.learningAndDevelopment,
          engagementScoreDoughnut: action.payload.data.engagementScoreDoughnut,
          performanceScoreDoughnut: action.payload.data.performanceScore,
          doingWell: action.payload.data.doingWell,
          needsImproving: action.payload.data.needsImproving,
          freedom: action.payload.data.freedom,
          meetingNeeds: action.payload.data.meetingNeeds,
        },
      }

    case "LOAD_DASHBOARD_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
        isLoading: false,
        loadingFailed: true,
        widgets: {
          ...state.widgets,
          performanceComparisonChart: { data: null, subtitle: null },
          lengthOfService: { data: null, subtitle: null },
          happyScale: { data: null, subtitle: null },
          challengesFaced: { data: null, subtitle: null },
          directReports: { data: null, subtitle: null },
          top5LD: { data: null, subtitle: null },
          doingWell: { data: null, subtitle: null },
          needsImproving: { data: null, subtitle: null },
          engagementScoreDoughnut: { data: null, subtitle: null },
          performanceScoreDoughnut: { data: null, subtitle: null },
          freedom: { data: null, subtitle: null },
          meetingNeeds: { data: null, subtitle: null },
          totalEmployees: { data: null, subtitle: null },
        },
      }
    case "COMPARISON_LINE_CHART_LOAD_COMPARISON_TYPE_SUCCESS":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          performanceComparisonChart: action.payload.data,
        },
      }
    case "COMPARISON_LINE_CHART_LOAD_COMPARISON_TYPE_FAIL": {
      // TODO: Change this to pop up window component
      alert("Comparison fail!")
      break
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/intelAndInsightsReducer.js